import {ACTIONS} from '@/common/auth/definitions/actions-methods';
import RESOURCES from '@/common/auth/definitions/resources';
import _ from '@/common/helpers';

const ROLE_TEMPLATES = [
    {
        value: 'customerServiceAgent',
        label: 'Customer Service Agent',
        permissions: {
            '3dsecure': [ACTIONS.read],
            attachments: [ACTIONS.all],
            bankAccounts: [ACTIONS.all],
            blacklists: [ACTIONS.add, ACTIONS.read],
            contacts: [ACTIONS.all],
            coupons: [ACTIONS.read],
            couponsRedemptions: [ACTIONS.all],
            customers: [ACTIONS.all],
            customerTimeline: [ACTIONS.all],
            customFields: [ACTIONS.read],
            disputes: [ACTIONS.all],
            emailMessages: [ACTIONS.all],
            emailNotifications: [ACTIONS.all],
            emailNotificationsTracking: [ACTIONS.all],
            files: [ACTIONS.all],
            gatewayAccountDowntimes: [ACTIONS.read],
            gatewayAccounts: [ACTIONS.read],
            gatewayAccountTimeline: [ACTIONS.read],
            invoices: [ACTIONS.all],
            leadSources: [ACTIONS.read],
            notes: [ACTIONS.all],
            organizations: [ACTIONS.read],
            paymentCards: [ACTIONS.all],
            paymentInstrumentValidation: [ACTIONS.all],
            payments: [ACTIONS.all],
            paypalAccounts: [ACTIONS.all],
            plans: [ACTIONS.read],
            products: [ACTIONS.read],
            search: [ACTIONS.all],
            shippingZones: [ACTIONS.read],
            subscriptions: [ACTIONS.all],
            subscriptionTracking: [ACTIONS.all],
            transactions: [ACTIONS.all],
            transactionTimeline: [ACTIONS.all],
            websites: [ACTIONS.read],
        },
    },
    {
        value: 'settingsManager',
        label: 'Settings Manager',
        permissions: {
            attachments: [ACTIONS.all],
            awsSesCredentials: [ACTIONS.all],
            blacklists: [ACTIONS.all],
            checkoutPages: [ACTIONS.all],
            coupons: [ACTIONS.all],
            couponsRedemptions: [ACTIONS.all],
            customFields: [ACTIONS.all],
            emailMessages: [ACTIONS.all],
            emailNotifications: [ACTIONS.all],
            emailNotificationsTracking: [ACTIONS.all],
            events: [ACTIONS.all],
            files: [ACTIONS.all],
            gatewayAccountDowntimes: [ACTIONS.all],
            gatewayAccounts: [ACTIONS.all],
            gatewayAccountTimeline: [ACTIONS.all],
            integrations: [ACTIONS.all],
            layouts: [ACTIONS.all],
            lists: [ACTIONS.all],
            listsTracking: [ACTIONS.all],
            mailgunCredentials: [ACTIONS.all],
            oauth2Credentials: [ACTIONS.all],
            organizations: [ACTIONS.all],
            plans: [ACTIONS.all],
            postmarkCredentials: [ACTIONS.all],
            products: [ACTIONS.all],
            rulesets: [ACTIONS.all],
            search: [ACTIONS.all],
            sendgridCredentials: [ACTIONS.all],
            sendPreviewEmail: [ACTIONS.all],
            sendPreviewWebhook: [ACTIONS.all],
            shippingZones: [ACTIONS.all],
            smtpCredentials: [ACTIONS.all],
            webhookCredentials: [ACTIONS.all],
            webhooks: [ACTIONS.all],
            websites: [ACTIONS.all],
        },
    },
    {
        value: 'fullManager',
        label: 'Full Manager',
        permissions: Object.keys(RESOURCES)
            .filter(v => v !== RESOURCES.users)
            .reduce(
                (result, item) => ({
                    ...result,
                    [item]: [ACTIONS.all],
                }),
                {users: [ACTIONS.edit, ACTIONS.read]},
            ),
    },
    {
        value: 'accountant',
        label: 'Accountant',
        permissions: {
            '3dsecure': [ACTIONS.read],
            activityFeed: [ACTIONS.read],
            attachments: [ACTIONS.all],
            bankAccounts: [ACTIONS.read],
            blacklists: [ACTIONS.all],
            contacts: [ACTIONS.read],
            coupons: [ACTIONS.all],
            couponsRedemptions: [ACTIONS.all],
            customers: [ACTIONS.read],
            customerTimeline: [ACTIONS.read],
            events: [ACTIONS.all],
            customFields: [ACTIONS.all],
            dataExports: [ACTIONS.all],
            disputes: [ACTIONS.read],
            files: [ACTIONS.all],
            gatewayAccountDowntimes: [ACTIONS.all],
            gatewayAccounts: [ACTIONS.all],
            gatewayAccountTimeline: [ACTIONS.all],
            invoices: [ACTIONS.read],
            leadSources: [ACTIONS.read],
            notes: [ACTIONS.read],
            organizations: [ACTIONS.all],
            paymentCards: [ACTIONS.read],
            paymentInstrumentValidation: [ACTIONS.read],
            payments: [ACTIONS.read],
            paypalAccounts: [ACTIONS.read],
            plans: [ACTIONS.all],
            products: [ACTIONS.all],
            reports: [ACTIONS.read],
            shippingZones: [ACTIONS.all],
            subscriptions: [ACTIONS.read],
            subscriptionTracking: [ACTIONS.read],
            transactions: [ACTIONS.read],
            transactionTimeline: [ACTIONS.read],
            users: [ACTIONS.read],
            websites: [ACTIONS.all],
        },
    },
];

/**
 * Takes a permission set and attempts to match against pre-defined role templates
 *
 * @param {object} permissions
 * @return {object}
 */
export function getMatchingRole(permissions) {
    let role = null;
    ROLE_TEMPLATES.forEach((template) => {
        if (_.isEqual(template.permissions, permissions)) {
            role = template;
        }
    });
    return role;
}

export default ROLE_TEMPLATES;
